import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, NavLink } from "react-router-dom";
import TableauDeBord from "./pages/TableauDeBord";
import RetraitDiplome from "./pages/RetraitDiplome";
import ChargementEtudiants from "./pages/ChargementEtudiants";
import ListeEtudiants from "./pages/ListeEtudiants";
import ListeRetrait from "./pages/ListeRetrait";

const navContainerStyle = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const menuStyle = {
  display: "flex",
  flexWrap: "wrap",      
  gap: "15px",
  padding: "10px",       
  margin: 0,             
  width: "100%",         
  background: "#2c3e50",
  justifyContent: "flex-start", 
  boxSizing: "border-box",      
};

const linkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontWeight: "bold",
  padding: "8px 15px",
  borderRadius: "4px",
  transition: "background 0.3s",
};

const activeLinkStyle = {
  backgroundColor: "#1abc9c",
};

function MenuHome({ token, user }) {
  return (
    <Router>
      <div style={navContainerStyle}>
        <nav style={menuStyle}>
          <NavLink
            to="/dashboard"
            style={({ isActive }) =>
              isActive ? { ...linkStyle, ...activeLinkStyle } : linkStyle
            }
          >
            Tableau de bord
          </NavLink>

          <NavLink
            to="/retrait-diplome"
            style={({ isActive }) =>
              isActive ? { ...linkStyle, ...activeLinkStyle } : linkStyle
            }
          >
            Retrait diplôme
          </NavLink>
          <NavLink
            to="/liste-retrait"
            style={({ isActive }) =>
              isActive ? { ...linkStyle, ...activeLinkStyle } : linkStyle
            }
          >
            Liste des rétraits
          </NavLink>

           <NavLink
            to="/liste-etudiants"
            style={({ isActive }) =>
              isActive ? { ...linkStyle, ...activeLinkStyle } : linkStyle
            }
          >
            Liste des inscriptions
          </NavLink>

          <NavLink
            to="/chargement-etudiants"
            style={({ isActive }) =>
              isActive ? { ...linkStyle, ...activeLinkStyle } : linkStyle
            }
          >
            Chargement des inscriptions
          </NavLink>

        </nav>

        <div style={{ padding: "20px", flex: 1 }}>
          <Routes>
            <Route path="/dashboard" element={<TableauDeBord />} />
            <Route path="/retrait-diplome" element={<RetraitDiplome />} />
            <Route path="/chargement-etudiants" element={<ChargementEtudiants />} />
            <Route path="/liste-etudiants" element={<ListeEtudiants />} />
            <Route path="/liste-retrait" element={<ListeRetrait />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default MenuHome;
